import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorNotificationService } from '../../../services/error-notification.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'gcp-workspace-error-notification',
    templateUrl: './error-notification.component.html',
    styleUrl: './error-notification.component.scss',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorNotificationComponent implements OnInit {
  message: string | null = null;
  private destroyRef = inject(DestroyRef);

  private readonly errorNotificationService = inject(ErrorNotificationService);
  private readonly snackBar = inject(MatSnackBar);

  ngOnInit() {
    this.errorNotificationService.error$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((message) => {
      this.message = message;
      this.snackBar.open(message, 'Close', {
        duration: 7000,
        panelClass: ['snackbar-error'],
      });
    });
  }
}
